import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import * as globals from '../globals';

@Injectable()
export class SendSupportEmailService {

  private supportUrl = globals.APIURL + '/supportemail';

  constructor(private authHttp: AuthHttp) { }
  
    sendSupportEmail(subject: string, message: string): Observable<Response> {
      console.log('sendSupportEmail service method called');
  
      let body = JSON.stringify({ supportemail: { subject: subject, message: message } });
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({ headers: headers });
      // console.log('URL =>', this.supportUrl);
      // console.log('OPTIONS =>', options);
  
      return this.authHttp.post(this.supportUrl, body);
    }
}


// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/send-support-email.service.ts